import { render, staticRenderFns } from "./UpdatedTermsModal.vue?vue&type=template&id=5bd0f348&scoped=true"
import script from "./UpdatedTermsModal.vue?vue&type=script&lang=js"
export * from "./UpdatedTermsModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatedTermsModal.vue?vue&type=style&index=0&id=5bd0f348&prod&scoped=true&lang=css"
import style1 from "./UpdatedTermsModal.vue?vue&type=style&index=1&id=5bd0f348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0f348",
  null
  
)

export default component.exports